
































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
  @Prop({ default: null }) body?: string;
  @Prop() title?: string;
  @Prop({ default: true }) showHeaderClose?: boolean;

  mounted() {
    document.addEventListener("keydown", e => {
      if (e.keyCode === 27) {
        this.close();
      }
    });
  }

  close() {
    this.$emit("close");
  }
}
